function initCheckoutCheckout() {
  $('[data-toggle="tab"]').on("shown.bs.tab", function (e) {
    $(this).children("input").trigger("click");
  });

  if (!$(".tab.active").length) {
    $(".tab:eq(0)").click();
  }
}
